<template>
  <v-form ref="form">
    <v-row class="pb-5">
      <v-col cols="12">
        <p class="primary--text form__title mb-5">
          E-MAIL COTAÇÃO
        </p>
      </v-col>
      <v-col cols="12" class="email-insurance__content mb-5 px-5">
        <p class="primary--text email-insurance__title-position">
          <span class="email-insurance__title-background px-1">
            Destinatários
          </span>
        </p>
        <div class="mb-5">
          <BaseDataTable
            :headers="tableHeaders"
            :items="itemsInsuranceToEmail"
            :items-per-page="5"
            show-select
            item-key="id"
            v-model="form.seguradora_destinatario"
          >
            <template v-slot:[`item.status_cotacao`]="{ item }">
              {{ item.status_cotacao || "Não há" }}
            </template>
            <template v-slot:[`item.limite_disponivel`]="{ item }">
              {{ asMoneyString(item.limite_disponivel) }}
            </template>
            <template v-slot:[`item.via_api`]="{ item }">
              {{ changeNameBoolean(item.via_api) }}
            </template>
          </BaseDataTable>
          <div
            v-if="errorInsurance.length > 0"
            class="v-text-field__details mt-4"
          >
            <div class="v-messages theme--light error--text" role="alert">
              <div class="v-messages__wrapper">
                <div
                  v-for="(message, index) in errorInsurance"
                  :key="`error-message-${index}`"
                  class="v-messages__message"
                >
                  {{ message }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <BaseFormSelect
            id-element="insuranceFilesQuotation"
            placeholder="Selecione"
            v-model="form.seguradora_destinatario"
            :items="itemsInsuranceToEmail"
            multiple
            label-text="Enviar para"
            item-text="nome"
            item-value="id"
            disabled
          />
        </div>
      </v-col>
      <v-col cols="12">
        <BaseFormInput
          id-element="titleEmailQuotation"
          placeholder="Inserir"
          v-model="form.assunto"
          required
          :rules="[requiredInput]"
          label-text="Assunto"
          validate-on-blur
        />
      </v-col>
      <v-col cols="12" md="6" class="pr-sm-5">
        <p class="mb-2 form__label primary--text">
          Corpo do E-mail
        </p>
        <BaseQuillEditor
          v-model="form.corpo_email"
          :error-messages="errorMessages"
        />
      </v-col>
      <v-col cols="12" md="6">
        <p class="mb-2 form__label primary--text">
          Selecione os anexos que serão enviados por e-mail
        </p>
        <DropFile
          @selected-files="addFilesEmail"
          :multiple="true"
          class="mb-5"
        />
        <DocumentDataTableSelectable
          :documents="fileItems"
          @preview-file="onPreviewFile"
          :disabled="true"
          :selectable="filesSelectable"
          @selectable="updateFilesSelectable"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-spacer />
      <v-col cols="12" sm="5" md="3" xl="2">
        <BaseButton
          v-html="'ENVIAR E-MAIL'"
          class="white--text secondary"
          width="100%"
          @click="submit"
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import { requiredInput } from "@/utils/rules.js";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import DocumentDataTableSelectable from "@/components/DocumentDataTableSelectable";
import DropFile from "@/components/DropFile";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import PolicyMixin from "@/mixins/PolicyMixin";
import { formatCEP } from "@brazilian-utils/brazilian-utils";
import {
  formatCpfOrCnpf,
  asMoneyString,
  formatIsoDateToDDMMYYYY
} from "@/utils/formats";

const tableHeaders = [
  { text: "Enviar Para (Seguradora)", value: "nome", sortable: true },
  { text: "Status Cotação", value: "status_cotacao", sortable: true },
  {
    text: "Limite de Crédito Dispónivel",
    value: "limite_disponivel",
    sortable: true
  },
  { text: "Integração API", value: "via_api", sortable: true }
];

export default {
  mixins: [DocumentsMixin, LoadingRequest, PolicyMixin],
  data() {
    return {
      form: {
        seguradora_destinatario: []
      },
      filesUpdated: [],
      requiredInput,
      tableHeaders,
      errorMessages: [],
      filesSelectable: [],
      errorInsurance: [],
      asMoneyString
    };
  },
  components: {
    DocumentDataTableSelectable,
    DropFile
  },
  computed: {
    ...mapState("quotation", ["itemsInsuranceToEmail"]),
    fileItems() {
      return _.concat(this.quotation.anexos, this.filesUpdated);
    },
    hasItems() {
      return this.fileItems.length > 0;
    },
    defaultEmailBody() {
      return `
        Prezados,
        <br><br>Segue abaixo pedido de cotação do produto ${this.quotation
          .modalidade?.nome || ""} - ${this.quotation.submodalidade?.nome || ""}
        <br><br>Dados do pedido:
        <br><br>Tomador: ${this.emailBodyTomador}
        <br><br>Segurado: ${this.emailBodySegurado}
        <br><br>Endereço: ${this.seguradoAddress}
        <br><br>${
          this.isJudicial ? this.emailBodyProcesso : this.emailBodyObjeto
        }
        <br><br>Valor importância segurada: ${asMoneyString(
          this.quotation.valor_importancia_segurada
        )}
        <br><br>Composição da importância segurada: ${this.quotation
          .composicao_importancia_segurada || ""}
        <br><br>Vigência: ${this.emailBodyVigencia}
        <br><br>Atenciosamente,
        <br><br>Lockton Brasil
      `;
    },
    defaultEmailSubject() {
      const { nome } = this.quotation.tomador.grupo;
      let numProcesso = this.quotation.processo.numero_processo;
      if (numProcesso) {
        numProcesso = " - N° PROCESSO " + numProcesso;
      }      
      return `Lockton | Solicitação de Cotação - ${this.quotation.submodalidade?.nome || ""} - ${nome ||
        "[GRUPO ECONÔMICO]"}${numProcesso || ""}`;
    },
    emailBodyTomador() {
      const { tomador } = this.quotation;
      return `${formatCpfOrCnpf(
        tomador.cnpj || tomador.cpf || tomador.numero_documento
      )} ${tomador.razao_social || tomador.nome}`;
    },
    emailBodyProcesso() {
      return `Processo: ${this.quotation.processo?.numero_processo}
        <br><br>Tribunal: ${this.quotation.processo?.tribunal?.nome || ""}
        <br><br>Vara do trabalho: ${this.quotation.processo?.unidade?.nome ||
          ""}`;
    },
    emailBodyObjeto() {
      return `Objeto do Seguro: ${this.quotation.informacoes_contrato || ""}`;
    },
    emailBodySegurado() {
      const { segurado } = this.quotation;
      let numInternoCliente = this.quotation.numero_interno_cliente;
      if (numInternoCliente) {
        numInternoCliente = "N° Interno: " + numInternoCliente;
      }  
      return `${formatCpfOrCnpf(
        segurado.cnpj || segurado.cpf || segurado.numero_documento
        )} ${segurado.razao_social || segurado.nome}
        <br><br>${numInternoCliente || ""}`;
    },
    seguradoAddress() {
      const {
        logradouro,
        numero,
        complemento,
        bairro,
        cidade,
        uf,
        cep
      } = this.quotation.segurado.endereco;
      return `${logradouro || ""} ${numero || ""} ${complemento ||
        ""} - ${bairro || ""} - ${cidade}, ${uf.sigla} - ${formatCEP(cep)}`;
    },
    emailBodyVigencia() {
      const { inicio_vigencia, fim_vigencia } = this.quotation;
      return `${
        inicio_vigencia ? formatIsoDateToDDMMYYYY(inicio_vigencia) : ""
      } - ${fim_vigencia ? formatIsoDateToDDMMYYYY(fim_vigencia) : ""}`;
    },
    isJudicial() {
      return this.quotation.modalidade.id === "judicial";
    }
  },
  methods: {
    ...mapActions("quotation", [
      "requestSendEmailInsuranceQuotation",
      "requestItemsInsuranceToEmail"
    ]),
    ...mapActions(["showAlertNotification"]),
    changeNameBoolean(item) {
      return item ? "SIM" : "NÃO";
    },
    async submit() {
      if (!this.validate()) return;
      this.withLoading(
        this.requestSendEmailInsuranceQuotation(
          await this.getPayloadInsuranceEmail()
        )
          .then(async () => {
            await this.requestItemsInsuranceToEmail(this.$route.params.id);
          })
          .then(() => {
            this.showAlertNotification({
              message: "E-mail enviado com sucesso.",
              type: "success"
            });
            this.form = {
              seguradora_destinatario: [],
              corpo_email: this.defaultEmailBody,
              assunto: this.defaultEmailSubject
            };
            this.$emit("sendEmail");
          })
      );
    },
    async getPayloadInsuranceEmail() {
      let payload = _.cloneDeep(this.form);
      payload.anexos = await this.submitFiles(this.filesSelectable);
      return {
        payload: payload,
        id: this.$route.params.id
      };
    },
    validate() {
      this.errorMessages = this.form.corpo_email
        ? []
        : ["É necessário colocar o corpo de email"];
      this.errorInsurance =
        this.form.seguradora_destinatario.length > 0
          ? []
          : ["É necessário selecionar na tabela pelo menos uma seguradora"];
      if (this.editing)
        this.showAlertNotification({
          message:
            "Termine a edição de custo para poder enviar e-mail para seguradoras.",
          type: "error"
        });
      return (
        this.$refs.form.validate() &&
        this.form.corpo_email &&
        this.form.seguradora_destinatario.length > 0 &&
        !this.editing
      );
    },
    addFilesEmail(files) {
      this.filesUpdated = this.addFiles(this.filesUpdated, files);
    },
    updateFilesSelectable(file) {
      this.filesSelectable = file;
    },
    setDefaultEmail() {
      this.form.corpo_email = this.defaultEmailBody;
      this.form.assunto = this.defaultEmailSubject;
    }
  },
  created() {
    this.setDefaultEmail();
  },
  props: {
    quotation: {
      type: Object
    },
    editing: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.email-insurance__
  &content
    border: 1px solid #D5D5E0
    border-radius: 4px
  &title-position
    margin-top: -13px
    margin-left: 20px
    padding-left: 2px
  &title-background
    background-color: #FAFAFC
</style>
